import api from "@/api/api";
import * as Helpers from "@/helpers";

export default {
  async Itens({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("notificacao_produto_silenciado", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setTitulo", resp.data.infoTitulo);
        commit("setItens", resp.data.itens);
        commit("setProdutoSilenciadoQtde", resp.data.qtde);
      })
      .catch(() => {
        Helpers.logout();
      });
  },
  async Item(store, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api.get("notificacao_produto_silenciado/" + params.id, {
      headers
    });
  },
  async Store({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api({
      method: "post",
      url: "notificacao_produto_silenciado",
      headers,
      data: params
    })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setTitulo", resp.data.infoTitulo);
        commit("setItens", resp.data.itens);
        commit("setProdutoSilenciadoQtde", resp.data.qtde);
      })
      .catch(() => {
        Helpers.logout();
      });
  },
  async Delete({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .delete("notificacao_produto_silenciado/" + params.id, {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setTitulo", resp.data.infoTitulo);
        commit("setItens", resp.data.itens);
        commit("setProdutoSilenciadoQtde", resp.data.qtde);
      })
      .catch(() => {
        Helpers.logout();
      });
  },
  async delecaoMultiplaDeProdutoSilenciados({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api({
        method: "post",
        url: "delecao_multipla_de_produto_silenciados",
        headers,
        data: params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setTitulo", resp.data.infoTitulo);
        commit("setItens", resp.data.itens);
        commit("setProdutoSilenciadoQtde", resp.data.qtde);
      })
      .catch(() => Helpers.logout());
  },
  async Qtde({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("notificacao_produto_silenciado_qtde", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setProdutoSilenciadoQtde", resp.data.qtdeProduto);
      })
      .catch(() => {
        Helpers.logout();
      });
  },
  async Motivo({ commit }) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("notificacao_produto_silenciado_motivo", {
        headers
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setMotivos", resp.data.itens);
      })
      .catch(() => {
        Helpers.logout();
      });
  }
};
